import React from "react";
import { Routes, Route, useLocation } from "react-router-dom";
import Header from "./Components/Header";
import Home from "./Components/Home/Home";
import "./CSS/Global.css";
import MyProperty from "./Components/Projects/MyProjects";
import Services from "./Components/Services/Service";
import AboutUs from "./Components/About-Us/AboutUs";
import ContactUs from "./Components/Forms/Contactus";
import Footer from "./Components/Footer";
import Blog from "./Components/Blog/Blog";
import AllCommentsPage from "./Components/Blog/AllCommentPage";
import BlogDetail from "./Components/Blog/BlogDetail";
import ScrollToTop from "./Components/ScrollToTop";
import ResidentDetailPage from "./Components/DetailPage/ResidentDetailPage";
import RentDetailPage from "./Components/DetailPage/RentDetailPage";
import CommercialDetailPage from "./Components/DetailPage/CommercialDetailPage";

function App() {
  const location = useLocation();
  const isHomePage = location.pathname === "/";

  return (
    <>
      <ScrollToTop />
      <Header isHomePage={isHomePage} />
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/properties" element={<MyProperty />} />
        <Route
          path="/residential-property/:id"
          element={<ResidentDetailPage />}
        />
        <Route
          path="/rent-property/:id"
          element={<RentDetailPage />}
        />
        <Route
          path="/commercial-property/:id"
          element={<CommercialDetailPage />}
        />
        <Route path="/services" element={<Services />} />
        <Route path="/about-us" element={<AboutUs />} />
        <Route path="/contact-us" element={<ContactUs />} />
        <Route path="/blog" element={<Blog />} />

        <Route path="/blogs/:name/:id" element={<BlogDetail />} />
        <Route path="/blogs/:blogId/comments" element={<AllCommentsPage />} />
      </Routes>
      <Footer />
    </>
  );
}

export default App;
